import React, { useEffect, useRef } from 'react';

import './style.css';
import { Row, Col } from 'react-bootstrap';
import LazyImage from '../../../../ui-core/Image';
import {
  user1,
  user1Webp,
  user2,
  user2Webp,
  user3,
  user3Webp,
  user4,
  user4Webp,
} from '../../images';
import { addAosAnimateClassObserver } from '../../../../utils/helpers';

export const IsThisYou = () => {
  const elementRef = useRef();
  useEffect(() => {
    const element = elementRef.current;

    const observer = addAosAnimateClassObserver();

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);
  return (
    <div
      className="is-this-you text-center"
      ref={elementRef}
      data-aos="fade-up"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <h2>
        Is this <em>You?</em>
      </h2>
      <div className="slider-section">
        <div className="slider">
          <Row>
            <Col md="3" lg="2" className="pl-0 p-lg-0">
              <LazyImage
                errorSrc={user1}
                placeholderSrc={user1Webp}
                src={user1Webp}
                className="w-100 img-fluid"
              />
            </Col>
            <Col md="9" className="offset-lg-1">
              <p>
                Do you get <em>a pinch</em> in your <em>shoulder</em> when you
                reach overhead?
              </p>
            </Col>
          </Row>
          <Row>
            <Col md="3" lg="2" className="pl-0 p-lg-0">
              <LazyImage
                errorSrc={user2}
                placeholderSrc={user2Webp}
                src={user2Webp}
                className="w-100 img-fluid"
              />
            </Col>
            <Col md="9" className="offset-lg-1">
              <p>
                Do your <em>upper traps</em> feel like <em>rocks</em> or
                constantly feel <em>neck tension</em>?
              </p>
            </Col>
          </Row>
          <Row>
            <Col md="3" lg="2" className="pl-0 p-lg-0">
              <LazyImage
                errorSrc={user3}
                placeholderSrc={user3Webp}
                src={user3Webp}
                className="w-100 img-fluid"
              />
            </Col>
            <Col md="9" className="offset-lg-1">
              <p>
                Do your <em>knees</em> bother you when <em>going downstairs</em>{' '}
                or <em>squatting</em> down?
              </p>
            </Col>
          </Row>
          <Row>
            <Col md="3" lg="2" className="pl-0 p-lg-0">
              <LazyImage
                errorSrc={user4}
                placeholderSrc={user4Webp}
                src={user4Webp}
                className="w-100 img-fluid"
              />
            </Col>
            <Col md="9" className="offset-lg-1">
              <p>
                Does your <em>low back</em> get <em>tight</em> and <em>achy</em>{' '}
                by the end of the day?
              </p>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
